export default "__VITE_ASSET__BMpTdZfY__"